import { Record } from "immutable";

const ReportRecord = Record({
  isRelease: false,
  itemId: "",
  reportStatus: null,
  diffAll: "",
  diffTime1: "",
  diffTime2: "",
  diffTime3: "",
  diffManufacture: "",
  diffNonManufacture: "",
  diffBigCorp: "",
  diffSmallCorp: "",
  diffIndustry1: "",
  industryId1: "",
  industryParentId1: "",
  diffIndustry2: "",
  industryId2: "",
  industryParentId2: "",
  diffIndustry3: "",
  industryId3: "",
  industryParentId3: "",
  freeInput1: "",
  freeInput2: "",
  reportDate: ""
});

export const STATUS = {
  WORKING: 1,
  FINISH: 2,
  ABORT: 9
};

class Report extends ReportRecord {
  isWorking() {
    return this.reportStatus === STATUS.WORKING;
  }
  isFinish() {
    return this.reportStatus === STATUS.FINISH;
  }
  isAbort() {
    return this.reportStatus === STATUS.ABORT;
  }
  // TODO: 作りかけ
  statusFmt(status = this.status) {
    switch (status) {
      case STATUS.WORKING:
        return "";
      case STATUS.FINISH:
        return "";
      case STATUS.ABORT:
        return "";
      default:
        throw new Error("unexpected args");
    }
  }
}

export default Report;



// WEBPACK FOOTER //
// ./src/models/Report.js